<template>
 <div
    class="close"
    @click="handleClose"
    :class="{ mobile: isMobile() && !sameBgInMobile, 'close--dark': dark }"
  >
    <svg
      :width="isMobile() ? 16 : 12"
      :height="isMobile() ? 16 : 12"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2L2 14"
        stroke="white"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
      <path
        d="M14 14L2 2"
        stroke="white"
        stroke-width="2"
        stroke-miterlimit="10"
        stroke-linecap="square"
      />
    </svg>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import UtilMixin from '@/mixins/util';

export default {
  name: 'close-button',
  mixins: [UtilMixin],
  props: {
    sameBgInMobile: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions('preQualify', ['close']),
    handleClose() {
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.close {
  z-index: 1;
  width: 24px;
  height: 24px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 4px;
  right: 4px;

  cursor: pointer;

  svg path {
    stroke: var(--gray-700);
  }

  &.mobile {
    background: transparent;
    width: 36px;
    height: 36px;
  }

  &--dark {
    background: rgba(0, 0, 0, 0.3) !important;
    &.mobile {
      background: rgba(0, 0, 0, 0.5) !important;
    }

    svg path {
      stroke: var(--white) !important;
    }
  }

}
</style>
